<script>
  import { getContext, createEventDispatcher } from 'svelte'
  import { getLayoutComponent } from './builder.js'

  export let label = 'Submit'
  // export let loading = false

  const dispatch = createEventDispatcher()
  const currentForm = getContext('currentForm')

  const submit = async () => {
    if (await currentForm.submit()) {
      dispatch('submit')
    } else {
      dispatch('error')
    }
  }
</script>

<svelte:component this={getLayoutComponent('Submit', false)} on:click={submit} {label} {...$$restProps} type="submit" />
